import { ResourceAuditList } from "@/features/resource-activity";
import type { Workflow } from "@/types/workflow.types";

interface ActivityTabProps {
  workflow: Workflow;
}

export default function ActivityTab({ workflow }: ActivityTabProps) {
  return (
    <div className="rounded-xl border border-[var(--border)] bg-[var(--card)] p-4">
      <ResourceAuditList resourceType="workflow" resourceId={workflow.id} limit={30} />
    </div>
  );
}
